import { Injectable } from "@angular/core";
import { ReplaySubject } from "rxjs";
import { Router } from "@angular/router";
import { NotlistService } from "app/modules/admin/notification-list/services/notlist.service";

@Injectable({
    providedIn: "root"
})

export class GenerateRouteService {


    constructor(private route: Router,
        private notiService :NotlistService) {

    }

    public queueCount = new ReplaySubject<any>(0);

    /** queue count */

    setQueueCount(property: any, storeProp: boolean = false) {
        if (storeProp) {
            localStorage.setItem('queueCount', JSON.stringify(property));
        }
        this.queueCount.next(property);
    }

    getQueueCount() {
        return this.queueCount;
    }

    // generateRoutePath(portalName, page, idObj) {
    //     let splitPath = page.split('_');
    //     let givenPathName = splitPath.pop();
    //     let givenModule = splitPath.join('-');
    //     let getPortalModules = routeModules[portalName];
    //     let { actualModule, path } = this.filterByModule(getPortalModules, givenModule);
    //     let pathName = this.filterByPath(path, givenPathName, idObj);
    //     portalName = portalName == 'teacher' ? '/' + portalName : portalName;
    //     return `${portalName}/${actualModule}/${pathName}`;
    // }

    // filterByModule(getPortalModules, moduleName) {
    //     return getPortalModules.find(el => el.givenModule == moduleName);
    // }

    // filterByPath(getPath, pathName, idObj) {
    //     let filteredPath = getPath.find(el => el.givenPath == pathName);
    //     return this.filterQueryParams(filteredPath, idObj);
    // }

    // filterQueryParams(params, idObj) {
    //     let pathQuery;
    //     if (params.isMultipleIdRequired == true) {
    //         let length = params.givenMulipleIds.length;
    //         if (length > 1) {
    //             pathQuery = params.givenMulipleIds.reduce((prev, curr) => String(idObj[prev]) + '/' + String(idObj[curr]))
    //         } else {
    //             pathQuery = idObj[params.givenMulipleIds[0]];
    //         }
    //     } else if (params.isSingleIdRequired == true) {
    //         pathQuery = params.actualPath + '/' + idObj[params.givensingleIdName];
    //     } else {
    //         pathQuery = params.actualPath;
    //     }
    //     return pathQuery; 
    // }

    navigateRouteForPhysio(portalName, page, idObj) {

    } 

    navigateRouteForDietitian(portalName, page, idObj) {

    }
 
    navigateRouteForGym(portalName, page, idObj) {

    }


    navigateRouteForAdmin(portalName,page,id){
      //console.log(id,'in the router service'); 
        if (page == 'ads_management') { 
            this.route.navigate(["/ads-management/view"], {queryParams: {adsId: id?.ads_id,notId:id?.random_id}});
        }
        else if (page == 'payment_transaction'){
            this.route.navigate([`/payment-transaction`], {queryParams:{notId:id?.random_id}});
        }
        else if(page == 'user_management'){
            this.route.navigate([`/user-management/view`], {queryParams: {userId: id?.customer_id,notId:id?.random_id}});
        }
        else  if(page == `feedback`){
            this.route.navigate([`/feedback`], {queryParams:{notId:id?.random_id}});
        }
        else{
            this.route.navigate([`/notification-list`], {queryParams: {notId:id?.random_id}});
        }
    } 


    array = { "key": "id", "value": "[2]", "description": "" }
}